import React, { Component } from 'react';
import { imageBasePath } from '../../constants/staticData';

export default class Offers extends Component {
    render() {
        return (
            <div className="vendor-services">
                <div className="vendor-description">
                    <h4>Offers</h4>
                    <div className="vendor-profile-offers">
                        <div className="offers-container">
                            <img src={`${imageBasePath}/images/deals2.png`} alt=""/>
                        </div>
                        <div className="offers-container">
                            <img src={`${imageBasePath}/images/deals3.png`} alt=""/>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
